import { CircularProgress } from '@material-ui/core';
import React, { ReactElement, useContext } from 'react';
import logo from './images/3d-Pos.png';
import { AppContext } from './state/app.state';

const LoadingTredenord: React.FC = (): ReactElement => {
    const { loading } = useContext(AppContext);

    const getLoadingText = () => {
        switch (loading) {
        case 'ok':
            return 'Allt gick fint';
        case 'api-error':
            return 'Ingen kontakt med servern';
        case 'no-project-id':
            return 'ProjektId saknas för boväljaren';
        case 'no-project-found':
            return 'Inget Boväljarprojekt hittat med inställt id';
        default:
            return '';
        }
    };

    return (<div className='bv-loading'>
        <img className='bv-loading-logo' src={logo} alt='logo'></img>
        {loading === 'loading' ? <CircularProgress className='bv-loading-circle'/> : <h2>{getLoadingText()}</h2>}

    </div>);
};


export default LoadingTredenord;